// Base
import { verifyBuild } from "../utils/verify-build";

const { isDevelopment } = verifyBuild();

const CLIENT_API_HOST = process.env.NEXT_PUBLIC_API_HOST;

export const CLIENT_API_URL = `${CLIENT_API_HOST}`;
export const PUBLIC_IMAGE_URL = isDevelopment ? `${CLIENT_API_URL}/` : "/";
